/**
 * Cross-page hook-free helpers for the universal search bar in the left ribbon.
 * Any page can call focusUniversalSearch() (e.g. from a "Search everything (⌘K)"
 * hint) — SidebarUniversalSearch listens for the event and focuses its input.
 */

export const UNIVERSAL_SEARCH_FOCUS_EVENT = "ds:focus-universal-search";

export function focusUniversalSearch(): void {
  window.dispatchEvent(new CustomEvent(UNIVERSAL_SEARCH_FOCUS_EVENT));
}
